import type { JSX } from 'react';
import { META } from '../config/content';
import { Hero } from '../components/Hero';
import { Page } from '../components/layout/Page';

/**
 * Meta for the one route that exists.
 *
 * These are written into the prerendered HTML at build time, which is the point — a crawler
 * that does not run JavaScript still gets a real title and a real Open Graph card.
 */
export function meta(): Record<string, string>[] {
  return [
    { title: META.title },
    { name: 'description', content: META.description },
    { property: 'og:title', content: META.title },
    { property: 'og:description', content: META.description },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: META.url },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: META.title },
    { name: 'twitter:description', content: META.description },
  ];
}

export default function Home(): JSX.Element {
  return (
    <Page>
      <Hero />
    </Page>
  );
}
